import { Filters } from "@/app/@types/filters";
import { defaultFilters } from "@/app/_constants/filters";
import React, { useState, createContext, ReactNode, useEffect } from "react";

type FiltersContext = Filters;

interface FiltersContextProps {
  filtersContext: FiltersContext;
  setFiltersContext: React.Dispatch<React.SetStateAction<FiltersContext>>;
}

const defaultFiltersContext: FiltersContext = defaultFilters;

export const FiltersContext = createContext<FiltersContextProps>({
  filtersContext: defaultFiltersContext,
  setFiltersContext: () => {},
});

interface FiltersProviderProps {
  children: ReactNode;
}

export const FiltersProvider = ({ children }: FiltersProviderProps) => {
  const [filtersContext, setFiltersContext] = useState<FiltersContext>(
    defaultFiltersContext
  );

  return (
    <FiltersContext.Provider value={{ filtersContext, setFiltersContext }}>
      {children}
    </FiltersContext.Provider>
  );
};
